/* eslint-disable react/display-name */
import React, { memo, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { withScreenSize } from '../../../common/utilities/withScreenSize.jsx';
import { reduxConnect } from '../../../../common';
import { getStatesByCountry, selectStateAction, selectContinentAction } from '../../../../common/actions/sitemapAction';
import { StatesByCountryType, SitemapContinents } from '../../../sitemap/common/types';
import { StatesContinentsListItemLink } from './statesContinentsListItemLink';

interface PageFooterStatesListProps {
    isDesktop: boolean;
    selectStateAction(
        countryName: string, 
        countryIso3: string, 
        stateName: string, 
        stateRoute: string, 
        stateCode?: string, 
        countryRoute?: string, 
        continentName?: string, 
        continentRoute?: string): void;
    getStatesByCountry: () => void;
    statesList: StatesByCountryType[];
    selectContinentAction(continentName: string, continentRoute: string): void;
}

const unitedStatesCountryName = 'United States';
const northAmericaRoutePath = '/sitemap/North-America';
// TECHDEBT: use value from common constants after merging PRs that come before this
const unitedStatesCountryIso = 'USA';
const unitedStateSitemapCountryBasePath = `${northAmericaRoutePath}/United-States/states`;
const unitedStateSitemapStateRoutePath = `${northAmericaRoutePath}/United-States/state`;

const mapStoreStateToProps = (storeState: any) => {
    const { sitemapLocations } =  storeState;
    const { statesList } = sitemapLocations || {};

    return {
        statesList
    };
};

const mapDispatchToProps  = {
    selectStateAction,
    getStatesByCountry,
    selectContinentAction
};

export const PageFooterStatesList = withScreenSize(reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({
    isDesktop,
    statesList=[],
    selectStateAction,
    getStatesByCountry
}: PageFooterStatesListProps) => {

    const isInitialLoad = useRef<number>(0);
    useEffect(() => {
        if (isDesktop && !statesList?.length && isInitialLoad.current < 3) { // race conditions with appState :/
            getStatesByCountry();
            isInitialLoad.current += 1;
        }
    }, [isDesktop, statesList]);

    if (!isDesktop || !statesList?.length) {
        return null;
    }

    return (
        <StatesListContainer key='states_list_footer'>
            {
                statesList?.map((state) => {
                    const stateNameForPath = state?.Name?.replace(' ', '-');
                    const stateRoute = `${unitedStateSitemapStateRoutePath}/${stateNameForPath}/${state?.Abbreviation}`;
    
                    return (
                        <StatesListItem key={`${state?.Name}_${state?.Abbreviation}`}>
                            <StatesContinentsListItemLink
                                onClick={() => selectStateAction(
                                    unitedStatesCountryName, 
                                    unitedStatesCountryIso, 
                                    state?.Name, 
                                    stateRoute,
                                    state?.Abbreviation,
                                    unitedStateSitemapCountryBasePath,
                                    SitemapContinents.NorthAmerica,
                                    northAmericaRoutePath
                                )}
                                href={stateRoute}>
                                {state?.Name}
                            </StatesContinentsListItemLink>
                        </StatesListItem>
                    );
                })
            }
        </StatesListContainer>
    );
})));

const StatesListContainer = styled.ul`
    display: block;
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    list-style-type: none;
    text-align: left;
    column-count: 5;
`;

const StatesListItem = styled.li`
    display: flex;
    flex-direction: row;
    line-height: 1.50;
    justify-content: flex-start;
    align-items: center;
`;